import { useEffect, useRef } from "react";
import axios from "axios";

const SECTIONS = ["home", "about", "work", "accolades", "connect", "contact"];
const DEPTH_MILESTONES = [25, 50, 75, 100];

export default function useScrollTracker(API) {
  const sessionId = useRef(crypto.randomUUID());
  const reported = useRef(new Set());
  const reportedSections = useRef(new Set());
  const startTime = useRef(Date.now());

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (docHeight <= 0) return;
      const pct = Math.round((scrollTop / docHeight) * 100);

      // Depth milestones
      for (const milestone of DEPTH_MILESTONES) {
        if (pct >= milestone && !reported.current.has(milestone)) {
          reported.current.add(milestone);
          const elapsed = (Date.now() - startTime.current) / 1000;
          axios.post(`${API}/analytics/scroll`, {
            session_id: sessionId.current,
            depth: milestone,
            time_on_page: elapsed,
          }).catch(() => {});
        }
      }

      // Section visibility
      for (const id of SECTIONS) {
        if (reportedSections.current.has(id)) continue;
        const el = document.getElementById(id);
        if (!el) continue;
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.6) {
          reportedSections.current.add(id);
          const elapsed = (Date.now() - startTime.current) / 1000;
          axios.post(`${API}/analytics/scroll`, {
            session_id: sessionId.current,
            depth: Math.round(pct),
            section: id,
            time_on_page: elapsed,
          }).catch(() => {});
        }
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [API]);
}
